import config from '@/config/index';
/**
 * ES搜索 -  政策搜索
 * @param policytype
 * @param governmenttype
 * @param policylevel
 * @param cityname
 * @param page           当前第几页
 * @param limit          限制多少页
 * @param request
 * @@GetMapping("/searchpolicy")
 */
function searchpolicy() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchpolicy`;
}

/**
 * 用户发起政策咨询
 *
 * @param title      标题
 * @param province   省份
 * @param district   地区
 * @param contacts   联系人
 * @param mobile     电话
 * @param verifycode 手机验证码
 * @param content    留言内容
 * @PostMapping("/policyaskfor")
 */
function policyaskfor() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/policyaskfor`;
}

/**
 * 获取用户本人提出的政策咨询以及答案
 *
 * @param request
 * @return @GetMapping("/userpolicyaskforlist")
 */
function getUserPolicyAskforList() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/userpolicyaskforlist`;
}
/**
 * 获取政策详情
 * @param pid
 * @param request
 * @return@GetMapping("/policy/{pid}")
 */
function getPolicy(pid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/policy/${pid}`;
}

export {
  searchpolicy,
  policyaskfor,
  getUserPolicyAskforList,
  getPolicy,
}
